/** @format */
import ListSubheader from "@mui/material/ListSubheader";
import List from "@mui/material/List";
import HelpCenterIcon from "@mui/icons-material/HelpCenter";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { Avatar, Box, Typography } from "@mui/material";
import NavItem from "./NavItem";
import Overlay from "./Overlay";
import LogoutNav from "./LogoutNav";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import { useSelector } from "react-redux";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import { useTranslation } from "react-i18next";
import i18n from "i18n";
import { useParams } from "react-router-dom";

export default function NestedList() {
  // @ts-ignore
  const { sidebarIsOpen } = useSelector((state) => state.layout);
  // @ts-ignore
  const { fullname } = useSelector((state) => state["Admin"].profileData);
  const {t, i18n: i18nInstance} = useTranslation();
  const { lang } = useParams(); // Get language from URL, e.g., 'fa' or 'en'

  const eduRoute = [
    {
      title: t("Sidebar.app"),
      icon: <PhoneIphoneIcon sx={{ color: "#fff", width: "1.5rem", height: "1.5rem" }} />,
      href: "https://app.copysa.ir/",
    },
    {
      title: t("Sidebar.dashboard"),
      icon: <DashboardIcon sx={{ color: "#fff", width: "1.5rem", height: "1.5rem" }} />,
      href: `/${lang}`,
    },
    {
      title: t("Sidebar.profile"),
      icon: <AccountBoxIcon sx={{ color: "#fff", width: "1.5rem", height: "1.5rem" }} />,
      href: `/${lang}/profile`,
    },
    {
      title: t("Sidebar.jozve"),
      icon: <InsertDriveFileIcon sx={{ color: "#fff", width: "1.5rem", height: "1.5rem" }} />,
      href: `/${lang}/file`,
    },
    {
      title: t("Sidebar.tutorial"),
      icon: <HelpCenterIcon sx={{ color: "#fff", width: "1.5rem", height: "1.5rem" }} />,
      href: `/${lang}/tutorial`,
    },
  ];
  const isRTL = (lang) => lang === "fa";
  // @ts-ignore
  const direction = isRTL(i18nInstance.language) ? "rtl" : "ltr";

  return (
    <>
    <Overlay direction={direction} />
    <List
      className={`transition-all duration-500 sidebar 
        ${direction === "rtl" ? "right-[-260px]" : "left-[-260px]"}
        ${sidebarIsOpen && direction === "rtl" ? "open !right-0" : ""}
        ${sidebarIsOpen && direction === "ltr" ? "open !left-0" : ""}
        text-white 
        h-screen top-0 pb-0 custom-scroll
        !fixed 
        overflow-x-hidden
        w-[260px]
        md:!sticky
        ${direction === "rtl" ? "md:right-0" : "md:left-0"}
        md:w-[72px] md:min-w-[72px]
        hover:!w-[260px]
        hover:!min-w-[260px]
        !font-bold
      `}
      sx={{
        bgcolor: "#40254E ",
        zIndex: 4,
      }}
      component="nav"
      aria-labelledby="nested-list-subheader"
      subheader={
        <>
          <ListSubheader
            sx={{
              paddingTop: "10px",
              bgcolor: "#40254E ",
              color: "#FFFBF4",
            }}
            component="div"
            id="nested-list-subheader"
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            ></Box>
          </ListSubheader>
          <ListSubheader
            sx={{
              paddingY: "15px",
              marginBottom: 1,
              borderBottom: "2px solid",
              bgcolor: "#40254E ",
              color: "#FFFBF4",
            }}
            component="div"
            id="nested-list-subheader"
          >
            <Box
              display="flex"
              alignItems="center"
              gap={1}
              flexDirection="column"
            >
              <Avatar></Avatar>
              <Typography
                className={`opacity-0 ${sidebarIsOpen && "opacity-100"}`}
              >
                {fullname}
              </Typography>
            </Box>
          </ListSubheader>
        </>
      }
    >
      { eduRoute.map((i) => <NavItem key={i.title} {...i} />)}

      <LogoutNav />
    </List>
  </>
  );
}
